//@ts-check

class UtilityinfoService {
	constructor($http, Utility, $timeout, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.userDetails = null;
		this.myProfileInformation = null;
	}
	
	async getBuildingUtilityInformation(schemeRef) {
		let promise, promiseHandler;

		promise = new Promise((resolve, reject) => {
			promiseHandler = {
				reject,
				resolve
			};
		});

		try {
			if (!!!schemeRef) {
				throw new Error('scheme Reference must be specified.');
			}

			let url = await this.InternalLinksService.getLink('LoadUtilitiesLink');
			if (!url) {
				await this.InternalLinksService.getLinks('api/dashboard/links');
				url = await this.InternalLinksService.getLink('LoadUtilitiesLink');
			}

			url = url.replace('{schemeRef}', schemeRef);
			const headers = this.Utility.headersWithContentType;			

			var results = await this.$http.get(url, { headers });

			let Data;
			if ('data' in results) {
				const { data: rawData } = results;
				Data = rawData;
			} else {
				Data = results;
			}
			const { Data: data, WasSuccessful: wasSuccessful } = Data;

			if (!wasSuccessful) {
				throw new Error('Error while loading utilities.');
			}

			promiseHandler.resolve(data);
		} catch (error) {
			promiseHandler.reject(error);
		}

		return promise;
	}

}

export default /* @ngInject */ ($http, Utility, $timeout, LocalStorageService, InternalLinksService) =>
	new UtilityinfoService($http, Utility, $timeout, LocalStorageService, InternalLinksService);
